import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import Dashboard from "./pages/Dashboard";
import Candidate from "./pages/Candidate/Candidates";
import CandidateLayout from "./layouts/CandidateLayout";
import CandidPersonalLayout from "./layouts/CandidPersonalLayout";
import Notes from "./pages/Candidate/SubPages/Notes";
import Interviews from "./pages/Candidate/SubPages/Interviews/Interviews";
import Projects from "./pages/Candidate/SubPages/Projects";
import CandidateTrainings from "./pages/Candidate/SubPages/Trainings";
import Documents from "./pages/Candidate/SubPages/Documents";
import Basic from "./pages/Candidate/SubPages/Personal/Basic";
import Professional from "./pages/Candidate/SubPages/Personal/Professional";
import Profile from "./pages/Candidate/SubPages/Personal/Profile";
import EmergencyContacts from "./pages/Candidate/SubPages/Personal/EmergencyContacts";
import CandidMarketLayout from "./layouts/CandidMarketLayout";
import MarketingHistory from "./pages/Candidate/SubPages/Marketing/MarketingHistory";
import MarketingList from "./pages/Candidate/SubPages/Marketing/MarketingList";
import MarketingNotes from "./pages/Candidate/SubPages/Marketing/MarketingNotes";
import MarketingJobs from "./pages/Candidate/SubPages/Marketing/MarketingJobs";
import Login from "./pages/Login/Login";
import RootLayout from "./layouts/RootLayout";
import CheckAuth from "./components/CheckAuth";
import SignUp from "./pages/Login/SignUp/SignUp";
import Subscribe from "./pages/Subscribe/Subscribe";
import ForgotPassword from "./pages/Login/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/Login/ResetPassword/ResetPassword";
import VerifyEmail from "./pages/Login/VerifyEmail/VerifyEmail";
import ChangePassword from "./pages/Login/ChangePassword/ChangePassword";
import UpdatePassword from "./pages/Login/UpdatePassword/UpdatePassword";
import SalesLayout from "./layouts/SalesLayout";
import JobLeads from "./pages/Sales/JobLeads/JobLeads";
import SalesInterviews from "./pages/Sales/Interviews/SalesInterviews";
import Vendors from "./pages/Sales/Vendors/Vendors";
import SalesContacts from "./pages/Sales/Contacts/SalesContacts";
import Technologies from "./pages/Sales/Technologies/Technologies";
import SalesTeams from "./pages/Sales/SalesTeams/SalesTeams";
import SalesProjects from "./pages/Sales/Projects/SalesProjects";
import VendorsLayout from "./layouts/VendorsLayout";
import Files from "./pages/Sales/Vendors/Subpages/Files";
import VendorSummaryLayout from "./layouts/VendorSummaryLayout";
import VendorDetailsLayout from "./layouts/VendorDetailsLayout";
import AccountInfo from "./pages/Sales/Vendors/Subpages/AccountInfo";
import Contacts from "./pages/Sales/Vendors/Subpages/Contacts";
import BillingAddress from "./pages/Sales/Vendors/Subpages/BillingAddress";
import CompanyProfile from "./pages/Sales/Vendors/Subpages/CompanyProfile";
import CompanyPreference from "./pages/Sales/Vendors/Subpages/CompanyPreference";
import BillingTerms from "./pages/Sales/Vendors/Subpages/BillingTerms";
import Description from "./pages/Sales/Vendors/Subpages/Description";
import Home from "./pages/Home/Home";
import TrainingLayout from "./layouts/TrainingLayout";
import Classes from "./pages/Training/Classes";
import Faculty from "./pages/Training/Faculty";
import AdminLayout from "./layouts/AdminLayout";
import Account from "./pages/Administration/Account";
import Users from "./pages/Administration/Users";
import UserRoles from "./pages/Administration/UserRoles";
import Settings from "./pages/Administration/Settings";
import SystemConfigs from "./pages/Administration/Settings/SystemConfigs";
import Trainings from "./pages/Training/Trainings";
import { useSelector } from "react-redux";
import '@aws-amplify/ui-react/styles.css'
import 'react-toastify/dist/ReactToastify.css';
import { VendorFormProvider } from "./pages/Sales/Vendors/VendorFormContext";
import { CandidateFormProvider } from "./pages/Candidate/CandidateFormContext";

function App() {
  // const [isAuth, setIsAuth] = useState(true);
  const isAuth = useSelector((state) => state.user.isAuth);
  //useApiInterceptor();
  return (
    <>
      <ToastContainer />
      <Routes>
        <Route
          path="/"
          element={
            <CheckAuth isAuth={isAuth}>
              <Home />
            </CheckAuth>
          }
        />
        <Route path="login" element={!isAuth ? <Login /> : <Home />} />
        <Route path="signup" element={<SignUp />} />
        <Route path="subscribe" element={<Subscribe />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="verify-email" element={<VerifyEmail />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="update-password" element={<UpdatePassword />} />
        <Route
          element={
            <CheckAuth isAuth={isAuth}>
              <RootLayout />
            </CheckAuth>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          {/* Candidate routes wrapped with shared form provider */}
          <Route path="candidate"
            element={
              <CheckAuth isAuth={isAuth}>
                <CandidateFormProvider>
                  <Outlet />
                </CandidateFormProvider>
              </CheckAuth>
            }
          >
            <Route index element={<Candidate />} />
            <Route path="add-candidate" element={<CandidateLayout />}>
            <Route path="personal" element={<CandidPersonalLayout />}>
              <Route index element={<Basic />} />
              <Route path="basic" element={<Basic />} />
              <Route path="professional" element={<Professional />} />
              <Route path="profile" element={<Profile />} />
              <Route
                path="emergency-contacts"
                element={<EmergencyContacts />}
              />
            </Route>
            <Route path="notes" element={<Notes />} />
            <Route path="marketing" element={<CandidMarketLayout />}>
              <Route index element={<MarketingHistory />} />
              <Route path="marketing-history" element={<MarketingHistory />} />
              <Route path="marketing-list" element={<MarketingList />} />
              <Route path="notes" element={<MarketingNotes />} />
              <Route path="jobs" element={<MarketingJobs />} />
            </Route>
            <Route path="interviews" element={<Interviews />} />
            <Route path="projects" element={<Projects />} />
            <Route path="trainings" element={<CandidateTrainings />} />
            <Route path="documents" element={<Documents />} />
            </Route>
          </Route>
          <Route path="sales" element={<SalesLayout />}>
            <Route path="job-leads" element={<JobLeads />} />
            <Route path="interviews" element={<SalesInterviews />} />
            <Route path="projects" element={<SalesProjects />} />
            <Route path="vendors" element={<Vendors />} />
               {/* Vendors route wrapped with form provider */}
               <Route path="vendors/*" element={<VendorFormProvider><VendorsLayout /></VendorFormProvider>}>
  {/* Sub-routes for vendors */}
                  {/* <Route path="new-vendor"> */}
                    <Route path="summary" element={<VendorSummaryLayout />}>
                      {/* Redirect /summary to /summary/account-info */}
                      <Route index element={<Navigate to="account-info" replace />} />
                      <Route path="account-info" element={<AccountInfo />} />
                      <Route path="account-info/:id" element={<AccountInfo />} /> {/* Add dynamic ID route */}
                      <Route path="contact" element={<Contacts />} />
                      <Route path="billing" element={<BillingAddress />} />
                    </Route>

                    <Route path="details" element={<VendorDetailsLayout />}>
                      {/* Redirect /details to /details/company-profile */}
                      <Route index element={<Navigate to="company-profile" replace />} />
                      <Route path="company-profile" element={<CompanyProfile />} />
                      <Route path="company-preference" element={<CompanyPreference />} />
                      <Route path="billing-terms" element={<BillingTerms />} />
                      <Route path="description" element={<Description />} />
                    </Route>

                    <Route path="files" element={<Files />} />
                  {/* </Route> */}
</Route>

            <Route path="contacts" element={<SalesContacts />} />
            <Route path="technologies" element={<Technologies />} />
            <Route path="sales-teams" element={<SalesTeams />} />
          </Route>
          <Route path="training" element={<TrainingLayout />}>
            <Route path="classes" element={<Classes />} />
            <Route path="faculty" element={<Faculty />} />
            <Route path="trainings" element={<Trainings />} />
          </Route>
          <Route path="admin" element={<AdminLayout />}>
            <Route path="account" element={<Account />} />
            <Route path="users" element={<Users />} />
            <Route path="user-roles" element={<UserRoles />} />
            <Route path="settings" element={<Settings />} />
            <Route path="system-configs" element={<SystemConfigs />} />
          </Route>
        </Route>
        {/* <Route path="/*" errorElement={<ErrorPage />} /> */}
      </Routes>
      {/* <RootLayout /> */}
    </>
  );
}

export default App;
